export const environment = {
  production: false,
  apiBaseUrl: 'http://103.120.179.127:8081/api/v1'
};